import { render } from "./Steps.vue?vue&type=template&id=70d8feda"
import script from "./Steps.vue?vue&type=script&lang=js"
export * from "./Steps.vue?vue&type=script&lang=js"

import "./Steps.vue?vue&type=style&index=0&id=70d8feda&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__